import { ActionTypes } from "../actions/projectFilters";

const defaultState = {
  appliedFilters: [],
};

const normalizeTrackableId = (trackableId) => Number(trackableId);

const removeTrackableFromAll = (appliedFilters, trackableId) => {
  const tid = normalizeTrackableId(trackableId);

  return appliedFilters
    .map((entry) => {
      const ids = (entry.appliedOnTrackableIds ?? []).filter(
        (id) => normalizeTrackableId(id) !== tid,
      );
      if (ids.length === 0) return null;
      return { ...entry, appliedOnTrackableIds: ids };
    })
    .filter(Boolean);
};

export default function projectFiltersReducer(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.APPLY_FILTER_TO_TRACKABLE: {
      const { filter, trackableId } = action.payload;
      const tid = normalizeTrackableId(trackableId);

      const withoutTrackable = removeTrackableFromAll(state.appliedFilters, tid);

      const existingIndex = withoutTrackable.findIndex((entry) => entry.id === filter.id);

      if (existingIndex >= 0) {
        const entry = withoutTrackable[existingIndex];
        const ids = [
          ...new Set([...(entry.appliedOnTrackableIds ?? []), tid]),
        ];
        withoutTrackable[existingIndex] = {
          ...entry,
          ...filter,
          appliedOnTrackableIds: ids,
        };
        return { ...state, appliedFilters: withoutTrackable };
      }

      return {
        ...state,
        appliedFilters: [
          ...withoutTrackable,
          {
            ...filter,
            appliedOnTrackableIds: [tid],
          },
        ],
      };
    }

    case ActionTypes.CLEAR_APPLIED_FILTER_FOR_TRACKABLE: {
      const { trackableId } = action.payload;
      return {
        ...state,
        appliedFilters: removeTrackableFromAll(state.appliedFilters, trackableId),
      };
    }

    default:
      return state;
  }
}